var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "log-activity-user-aside" }, [
      _c("div", { staticClass: "aside-wrap" }, [
        _c("div", { staticClass: "aside-item" }, [
          _c("img", {
            attrs: {
              src: require("@/assets/icon/login.svg"),
              alt: "login-icon"
            }
          }),
          _vm._v(" "),
          _c("span", [_vm._v("Login")])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a14c951", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a14c951","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user-employee/log-activity/jLogActivityAside.vue
// module id = null
// module chunks = 